var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNaira(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 512 512",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Untitled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M170.808 0.409553L341.202 0.409553L341.202 0.409553L341.202 511.592L341.202 511.592L170.808 511.592L170.808 511.592L170.808 0.409553L170.808 0.409553Z",
    fill: "#ffffff",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M341.192 0.409553L511.586 0.409553L511.586 0.409553L511.586 511.592L511.586 511.592L341.192 511.592L341.192 511.592L341.192 0.409553L341.192 0.409553Z",
    fill: "#259245",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.409636 0.409553L170.804 0.409553L170.804 0.409553L170.804 511.592L170.804 511.592L0.409636 511.592L0.409636 511.592L0.409636 0.409553L0.409636 0.409553Z",
    fill: "#259245",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNaira);
export default __webpack_public_path__ + "static/media/naira.9dda28577291b3e7af99acc1ae9a9a4d.svg";
export { ForwardRef as ReactComponent };